/* Daedalus / Dayd wordmarks — ported from
   design_handoff_daedalus/design_files/brand.jsx */

type WordmarkProps = {
  size?: number;
  color?: string;
};

export function DaedalusWordmark({ size = 22, color }: WordmarkProps) {
  const c = color || 'currentColor';
  return (
    <span
      style={{
        fontFamily: 'IBM Plex Serif, serif',
        fontSize: size,
        fontWeight: 500,
        letterSpacing: '-.01em',
        color: c,
        lineHeight: 1,
      }}
    >
      Daedalus<span style={{ color: '#f3c94a' }}>.</span>
    </span>
  );
}

export function DaydWordmark({ size = 44, color }: WordmarkProps) {
  const c = color || 'currentColor';
  return (
    <svg
      viewBox="0 0 120 44"
      width={(size * 120) / 44}
      height={size}
      style={{ display: 'block' }}
    >
      <text x="0" y="34" fontFamily="IBM Plex Serif, serif" fontWeight="500" fontSize="40" fill={c} letterSpacing="-1.2">d</text>
      <text x="25" y="34" fontFamily="IBM Plex Serif, serif" fontWeight="500" fontSize="40" fill={c} letterSpacing="-1.2">a</text>
      <text x="50" y="34" fontFamily="IBM Plex Serif, serif" fontWeight="500" fontSize="40" fill={c} letterSpacing="-1.2">y</text>
      <text x="75" y="34" fontFamily="IBM Plex Serif, serif" fontWeight="500" fontSize="40" fill={c} letterSpacing="-1.2">d</text>
      <circle cx="63" cy="10" r="2.6" fill="#f3c94a" />
    </svg>
  );
}
